import Linkify from 'linkify-react';
import type { ReactNode } from 'react';

interface MessageLinkifyProps {
  children: ReactNode;
}

export function MessageLinkify({ children }: MessageLinkifyProps) {
  return (
    <Linkify
      options={{
        defaultProtocol: 'https',
        nl2br: true,
        target: { url: '_blank' },
        rel: { url: 'noopener noreferrer' },
        render: ({ attributes, content }) => (
          <a {...attributes} style={{ color: 'inherit', textDecoration: 'underline' }}>
            {content}
          </a>
        ),
      }}
    >
      {children}
    </Linkify>
  );
}
